import { FC, useMemo } from 'react'

import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'

import CloseIcon from '@mui/icons-material/Close'

import { KnightColors } from 'theme'

const UglyDialogBackgroundColor = KnightColors.Paper
const UglyDialogBorderColor = KnightColors.TextBrown

const UDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    borderRadius: 20,
    border: `1px solid ${UglyDialogBorderColor}`,
    backgroundColor: UglyDialogBackgroundColor,
    maxWidth: 360,
  },
})

export interface UglyTitleProps {
  children?: React.ReactNode
  onClose: () => void
}

const UTitle = (props: UglyTitleProps) => {
  const { children, onClose } = props

  const closeButton = useMemo(
    () =>
      onClose ? (
        <Box position="absolute" pt={1.2} pr={1.5} top={0} right={0} color="#000">
          <IconButton aria-label="close" onClick={onClose} color="inherit">
            <CloseIcon color="inherit" />
          </IconButton>
        </Box>
      ) : null,
    [onClose]
  )

  return (
    <DialogTitle>
      <Box width="100%" textAlign="center">
        <Typography variant="UglyDialogTitle">{children}</Typography>
      </Box>

      {closeButton}
    </DialogTitle>
  )
}

interface UglyDialogProps extends DialogProps {}

const UglyDialog: FC<UglyDialogProps> = ({ title, children, ...props }) => {
  return (
    <UDialog fullWidth {...props}>
      <UTitle onClose={props.onClose as () => void}>{title}</UTitle>
      <DialogContent>
        {children}
      </DialogContent>
    </UDialog>
  )
}

export default UglyDialog
